var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['logo-' + _vm.bookieCode, 'bookies', 'center']})
}
var staticRenderFns = []

export { render, staticRenderFns }